import React from 'react'
import { Route, Redirect, Switch, withRouter } from 'react-router'
import { connect } from 'react-redux'
import Layout from './Layout'
import Companies from './Companies/Companies'
import CompanyContainer from './CompanyContainer/CompanyContainer'

const CompaniesRoute = () => <Layout slot={<Companies />} />
const CompanyRoute = () => <Layout slot={<CompanyContainer />} />

const AppContainer = () => (
  <Switch>
    <Route exact path="/" component={CompaniesRoute} />
    <Route path="/companies/:id" component={CompanyRoute} />
    <Route render={() => <Redirect to="/" />} />
  </Switch>
)

const mapStateToProps = () => ({})

const mapDispatchToProps = () => ({})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AppContainer))



// WEBPACK FOOTER //
// ./src/Containers/AppContainer.jsx